import { DELETE_REQUESTED } from '../../../../services/core/reducerFactory/types';

export default {
  OPEN_MODAL: 'OPEN_DELETE_MODAL',
  DELETE_REQUESTED: DELETE_REQUESTED.replace('*', 'csServices'),
  CANCEL: 'CANCEL_DELETE_ITEM'
};
